import { render } from "./CollapseButton.vue?vue&type=template&id=0c9cf314&scoped=true"
import script from "./CollapseButton.vue?vue&type=script&lang=js"
export * from "./CollapseButton.vue?vue&type=script&lang=js"

import "./CollapseButton.vue?vue&type=style&index=0&id=0c9cf314&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c9cf314"]])

export default __exports__